import { Components, ComponentsProps } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import { FlexColumn } from "../../Styles";
import VideoPlayerProps from "../VideoPlayer";

const playbackList = [
  "0.25x",
  "0.5x",
  "0.75x",
  "1x",
  "1.25x",
  "1.5x",
  "1.75x",
  "2x",
];
const videoQualityList = ["Auto", "360p", "480p", "720p", "1080p HD"];

const SettingsDropdown = ({
  setIsSettingsShow,
  playbackSpeed,
  setPlaybackSpeed,
}: VideoPlayerProps.SettingsDropdownProps) => {
  const { typography } = useTheme();
  const settingsRef = useRef<HTMLDivElement>(null);
  const [videoQuality, setVideoQuality] = useState("Auto");
  const [settingOpenTab, setSettingOpenTab] =
    useState<VideoPlayerProps.SettingTab>("");
  useClickOutside({ ref: settingsRef, setState: setIsSettingsShow });

  return (
    <Container ref={settingsRef} onClick={(e) => e.stopPropagation()}>
      <Components.Menu size="fill" withBackground>
        {settingOpenTab ? (
          <FlexColumn $gapInPx={8}>
            <HeaderContainer>
              <Components.IconButton
                iconType="ArrowLeft"
                onClick={() => {
                  setSettingOpenTab("");
                }}
                disabled={false}
                kind="Opacity"
                size="XXS"
              />
              <Components.Text
                style={{ tokenStyle: typography.Body.M }}
                text={settingOpenTab}
                fontWeight="font-weight-semibold"
              />
            </HeaderContainer>
            {(settingOpenTab === "Playback"
              ? playbackList
              : videoQualityList
            ).map((item, index) => (
              <Components.ListItem
                key={index}
                type="List Item"
                label={item}
                selected={
                  settingOpenTab === "Playback"
                    ? playbackSpeed === item
                    : videoQuality === item
                }
                onClick={(
                  option: ComponentsProps.ListItemProps.DefaultListItemProps
                ) => {
                  if (settingOpenTab === "Playback") {
                    setPlaybackSpeed(option.label);
                  } else {
                    setVideoQuality(option.label);
                  }
                }}
                radio={true}
              />
            ))}
          </FlexColumn>
        ) : (
          <FlexColumn $gapInPx={8}>
            <Components.ListItem
              type="List Item"
              label="Playback"
              onClick={() => {
                setSettingOpenTab("Playback");
              }}
              iconType="Play"
              count={playbackSpeed}
              countColor="Light"
            />
            <Components.ListItem
              type="List Item"
              label="Video Quality"
              onClick={() => {
                setSettingOpenTab("Video Quality");
              }}
              iconType="Film"
              count={videoQuality}
              countColor="Light"
            />
          </FlexColumn>
        )}
      </Components.Menu>
    </Container>
  );
};

export default SettingsDropdown;

const Container = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing["spacing-7"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-7"].value}rem;
  justify-content: center;
  align-items: center;
  width: 300px;

  .list-item {
    min-height: ${({ theme }) => theme.spacing["spacing-8"].value}rem;
    height: ${({ theme }) => theme.spacing["spacing-8"].value}rem;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
